export default "__VITE_ASSET__BfZuKa2___"